import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";

export default function AccountStatusExt(param: any) {

  const [AccountStatusEx, SetAccountStatusEx] = useState<any>([]);
  useEffect(() => {

    if (param.activeTab === "Account Status Ext") {
      AccountStatusExSelect()
    }
  }, [param])

  const AccountStatusExSelect = () => {
    var payload = {}
    systemListingService.statusAccountExtList(payload).then((res:any) => { SetAccountStatusEx(res) })
  }

  const [editingOn, setEditingOn] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState<"add" | "edit">("add");
  const [editingRowId, setEditingRowId] = useState<number | null>(null);

  return (
    <div className="content-card ws-12">
      {/* Top edit tab */}
      <div className="ptl pbl ws-12">
        <span className="text-bold">Account Status Ext</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}  >
          {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
        </button>

      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className={editingOn ? "editing-on newTable" : "newTable"}>
          <thead>
            <tr>
              <th >Status ID</th>
              <th >Status Name</th>
              <th >Status Short Code</th>
              <th >Rec MYN</th>
              <th >Pub lYN</th>
              <th >Mech YN</th>
              <th >Approval YN</th>
              <th >Control Rpt YN</th>
              <th >Email YN</th>
              <th >Auto LTD</th>
              <th style={{ width: "19%" }}>Operations</th>
            </tr>
          </thead>

          <tbody>
            {AccountStatusEx.map((row: any) => (
              <tr key={row.id}>
                <td>{row.acctStatusExtUseID}</td>
                <td>{row.acctStatusExtName}</td>
                <td>{row.acctStatusExtShortCode}</td>

                <td>
                  <div className={"pp-switch" + (row?.recMYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.publYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.mechYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.approvalYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.controlRptYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.emailYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.autoLTD === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>
                  <button className={`btn-default ${row.isDefault ? "active" : ""}`} type="button" disabled={!editingOn}>
                    Default
                  </button>

                  <button className="icon-btn edit" type="button" disabled={!editingOn}>
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 20h9" />
                      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
                    </svg>
                  </button>

                  <button className="icon-btn delete" type="button" disabled={!editingOn}>
                    <i className="icon-trash"> </i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add row button + Save */}
      <div className="add-row-wrapper">
        <button
          id="addRowBtn"
          className={`btn-add-row ${!editingOn ? "disabled" : ""}`}
          type="button"
          disabled={!editingOn}
        >
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Add Account Status Ext
        </button>

        <button
          id="tableSaveBtn"
          className="btn-save-table"
          type="button"
          disabled={!editingOn}
          onClick={() => {
            ;
            setEditingOn(false);
          }}
        >
          Save Changes
        </button>
      </div>

    </div>
  );
};

